var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logo)?_c('div',{class:_vm.small ? 'image-bg-container-small mx-2' : 'image-bg-container',style:('background:url(' + _vm.logo + ')')}):_c('div',{class:_vm.small ? 'image-bg-container-small mx-2' : 'image-bg-container',style:('background:url(' + _vm.defaultLogo + ')')})])
}
var staticRenderFns = []

export { render, staticRenderFns }